import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import { primaryColor } from "assets/jss/xrs.js";

import PayNow from "../SectionsPage/Sections/PayNowSection.js";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import BlueHeader from "../SectionsPage/Sections/BlueHeaderSection.js";
import Context from "../../utils/context";
import { Box } from "@mui/material";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;

let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => ({
  content: {
    padding: theme.spacing(3),

    paddingTop: 60,
    paddingBottom: 38,
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
}));

export default function PayNowPage(props) {
  const { classes: classes2, cx } = useStyles2();
  const context = useContext(Context);
  const [page, setPage] = React.useState(1);

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <main
        className={cx(classes2.content, {
          [classes2.contentShift]: context.stateDrawer,
        })}
      >
        <HeaderSectionLoggedID
          page="paynow"
          title="Pay Now"
        ></HeaderSectionLoggedID>

        <BlueHeader></BlueHeader>

        <PayNow showdate={false} enabled="true" source="PayNow"></PayNow>
      </main>
    </Box>
  );
}
